import { useSelector } from 'react-redux';
import { getSession } from './bentoApiModule';
export default function useSession() {
  return useSelector(getSession);
}